import React, { PropsWithChildren } from 'react';
import {
  MealDeliveryProvider as CommonMealDeliveryProvider,
  useMealDeliveryContext as useCommonMealDeliveryContext,
  useReviewDeliveryData as useCommonReviewDeliveryData,
  useChooseMealsData as useCommonChooseMealsData,
  type MealDeliveryContextType,
} from '@fdha/common-hooks';
import { DeliveryStatus } from '@fdha/graphql-api-admin';

import { useWebPlatformBridge } from './WebPlatformBridge';

interface MealDeliveryProviderProps extends PropsWithChildren {
  patientId?: string;
  dietPlanDeliveryMenuId?: string;
  foodProgramUserId?: string;
  deliveryId?: string;
  deliveryStatus?: DeliveryStatus;
  isCanceled?: boolean;
}

// Web-specific provider that wraps the common provider with a web platform bridge
export const MealDeliveryProvider: React.FC<MealDeliveryProviderProps> = ({
  children,
  patientId,
  dietPlanDeliveryMenuId,
  foodProgramUserId,
  deliveryId,
  deliveryStatus,
  isCanceled,
}) => {
  const bridge = useWebPlatformBridge();

  return (
    <CommonMealDeliveryProvider
      bridge={bridge}
      patientId={patientId}
      dietPlanDeliveryMenuId={dietPlanDeliveryMenuId}
      foodProgramUserId={foodProgramUserId}
      deliveryId={deliveryId}
      deliveryStatus={deliveryStatus}
      isCanceled={isCanceled}
    >
      {children}
    </CommonMealDeliveryProvider>
  );
};

// Re-export hooks with web-specific naming
export const useMealDeliveryContext = useCommonMealDeliveryContext;
export const useReviewDeliveryData = useCommonReviewDeliveryData;
export const useChooseMealsData = useCommonChooseMealsData;

// Re-export types
export type { MealDeliveryContextType };
